<div class="row no-padding justify-content-center full-hight">
  <div class="col-10 side-nav-content full-hight">
    <div class="row justify-content-center side-content full-hight">
      <div class="col-12">
        <div class="row justify-content-center">

          <!-- AUTOPARTAGE -->
          <div class="col-12 margin-block-s">
            <a routerLink="/autopartage" routerLinkActive="active">
              <button class="menu-btn titleBookkBorder" mat-stroked-button (click)="CloseAction();">
                <img *ngIf="site !== 'remi'" class="menu-icon-img" src="../../../assets/img/Pictos_Appli/Vert/SVG/Picto_Depart-retour.svg"/>
                <span>{{ 'MENU.CONNECTE.BOUTON1' | translate }}</span>
              </button>
            </a>
          </div>

          <!-- USER -->
          <div class="col-12 margin-block-s">
            <a routerLink="/user" routerLinkActive="active">
              <button class="menu-btn titleBookkBorder" mat-stroked-button (click)="CloseAction();">
                <img *ngIf="site !== 'remi'" class="menu-icon-img" src="../../../assets/img/Pictos_Appli/Vert/SVG/Picto_Utilisateur.svg"/>
                <span>{{ 'MENU.CONNECTE.BOUTON2' | translate }}</span>
              </button>
            </a>
          </div>

          <!-- <hr class="col-10"> -->

          <!-- FORMULE -->
          <div class="col-12 margin-block-s">
            <a routerLink="auth/ma-formule" routerLinkActive="active">
              <button class="menu-btn titleBookkBorder" mat-stroked-button (click)="CloseAction();">
                <img *ngIf="site !== 'remi'" class="menu-icon-img" src="../../../assets/img/Pictos_Appli/Vert/SVG/Picto_Contrat.svg"/>
                <span>{{ 'MENU.CONNECTE.BOUTON3' | translate }}</span>
              </button>
            </a>
          </div>

          <!-- RESERVATIONS -->
          <div class="col-12 margin-block-s">
            <a routerLink="auth/reservations" routerLinkActive="active">
              <button class="menu-btn titleBookkBorder" mat-stroked-button (click)="CloseAction();">
                <img *ngIf="site !== 'remi'" class="menu-icon-img" src="../../../assets/img/Pictos_Appli/Vert/SVG/Picto_Reservation.svg"/>
                <span>{{ 'MENU.CONNECTE.BOUTON4' | translate }}</span>
              </button>
            </a>
          </div>

          <!-- CONSOMMATIONS -->
          <div *ngIf="_currentUser?.community?.id === 153" class="col-12 margin-block-s">
            <a routerLink="auth/consommations" routerLinkActive="active">
              <button class="menu-btn titleBookkBorder" mat-stroked-button (click)="CloseAction();">
                <img *ngIf="site !== 'remi'" class="menu-icon-img" src="../../../assets/img/Pictos_Appli/Vert/SVG/Picto_Reservation.svg"/>
                <span>{{ 'MENU.CONNECTE.BOUTON41' | translate }}</span>
              </button>
            </a>
          </div>

          <!-- PAIEMENTS -->
          <div class="col-12 margin-block-s">
            <a routerLink="auth/mes-paiements" routerLinkActive="active">
              <button class="menu-btn titleBookkBorder" mat-stroked-button (click)="CloseAction();">
                <img *ngIf="site !== 'remi'" class="menu-icon-img" src="../../../assets/img/Pictos_Appli/Vert/SVG/Picto_Paiement.svg"/>
                <span>{{ 'MENU.CONNECTE.BOUTON5' | translate }}</span>
              </button>
            </a>
          </div>

          <!-- BILAN -->
          <div class="col-12 margin-block-s">
            <a routerLink="auth/mon-bilan-carbone" routerLinkActive="active">
              <button class="menu-btn titleBookkBorder" mat-stroked-button (click)="CloseAction();">
                <img *ngIf="site !== 'remi'" class="menu-icon-img" src="../../../assets/img/Pictos_Appli/Vert/SVG/Picto_Feuille.svg"/>
                <span>{{ 'MENU.CONNECTE.BOUTON6' | translate }}</span>
              </button>
            </a>
          </div>

          <!-- INFO -->
          <div class="col-12 margin-block-s">
            <a [href]="urlInform">
              <button class="menu-btn titleBookkBorder" mat-stroked-button (click)="CloseAction();">
                <img *ngIf="site !== 'remi'" class="menu-icon-img" src="../../../assets/img/Pictos_Appli/Vert/SVG/picto_information.svg"/>
                <span>{{ 'MENU.CONNECTE.BOUTON9' | translate }}</span>
              </button>
            </a>
          </div>

          <!-- COVOITURAGE -->
          <div *ngIf="_currentUser?.partage_trajet === true" class="col-12 margin-block-s">
            <a [href]="urlCovoiturage">
              <button class="menu-btn titleBookkBorder" mat-stroked-button (click)="CloseAction();">
                <img *ngIf="site !== 'remi'" class="menu-icon-img" src="../../../assets/img/Pictos_Appli/Vert/SVG/Picto_Volant.svg"/>
                <span>{{ 'MENU.CONNECTE.BOUTON10' | translate }}</span>
              </button>
            </a>
          </div>

          <!-- FAQ -->
          <div class="col-12 margin-block-s">
            <a routerLink="faq" routerLinkActive="active">
              <button class="menu-btn titleBookkBorder" mat-stroked-button (click)="CloseAction();">
                <img *ngIf="site !== 'remi'" class="menu-icon-img" src="../../../assets/img/Pictos_Appli/Vert/SVG/Picto_FAQ.svg"/>
                <span>{{ 'MENU.CONNECTE.BOUTON7' | translate }}</span>
              </button>
            </a>
          </div>

          <hr class="col-10">

          <!-- LOGOUT -->
          <div class="col-12 margin-block-s">
            <a routerLink="/">
              <button class="menu-btn titleBookkBorder" mat-stroked-button (click)="disconnect();">
                <img *ngIf="site !== 'remi'" class="menu-icon-img" src="../../../assets/img/Pictos_Appli/Vert/SVG/Picto_Connexion.svg"/>
                <span>{{ 'MENU.CONNECTE.BOUTON8' | translate }}</span>
              </button>
            </a>
          </div>

        </div>
      </div>

      <!-- FOOTER -->
      <div class="col-12 user-info align-self-end">

        <h4 class="d-flex justify-content-center align-items-center mt-3">
          <mat-icon *ngIf="site !== 'remi'">email</mat-icon>
          <a class="ml-2" href="https://www.clem-e.com/contactusager">{{ 'MENU.CONNECTE.BOUTON11' | translate }}</a>
        </h4>

        <h5 *ngIf="site === 'default'" class="d-flex justify-content-center align-items-center">
          <mat-icon>phone</mat-icon>
          <span class="ml-2">+331 86 86 85 85</span>
        </h5>

        <h5 *ngIf="site === 'mam'" class="d-flex justify-content-center align-items-center">
          <mat-icon>phone</mat-icon>
          <span class="ml-2">+33 4 15 85 95 72</span>
        </h5>

        <h5 *ngIf="site === 'remi'" class="d-flex justify-content-center">
          +33(0) 806 70 33 33
        </h5>

        <!-- LANG -->
        <div class="d-flex mb-4 justify-content-center mt-2">
          <select #langSelect (change)="translate.use(langSelect.value)">
            <option *ngFor="let lang of locales"
                    [value]="lang.value"
                    [selected]="lang.value === translate.currentLang">
              {{ lang.label }}
            </option>
          </select>
        </div>

      </div>

    </div>
  </div>
</div>